<div>
  <app-second-committee-admin-dialog></app-second-committee-admin-dialog>
  <app-poller></app-poller>
  <router-outlet></router-outlet>
  <p-confirmDialog></p-confirmDialog>
  <p-toast></p-toast>
  <app-download-tray></app-download-tray>
</div>
